module.exports = __webpack_public_path__ + "img/svg/identity.9d5f380b6152bc1275aff0bf5cb3cebb.svg";